const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import * as telegram from './telegram'
import * as utils from './utils'
import { BaseObject, MongoObject } from './_baseClasses'

export enum alertStatus {
  Enabled = 1, Disabled = 2
}

export enum alertChannel {
  Email = 1, SMS = 2, Browser = 3, Discord = 4, Telegram = 5
}

export class Alert extends MongoObject {
  protected static collectionName: string = 'alerts'           // IMPORTANT

  public userId: string = null          // TokenUser id of the user who created the alert
  public alertName: string = null
  public status: alertStatus = null
  public channels: alertChannel[] = null

  // criteria
  public minPrice: number = null
  public maxPrice: number = null
  public dealRating: number = null
  public playerID: number = null
  public setID: number = null           // numeric setID used by flow
  public playID: number = null          // numeric playID used by flow
  public minSerial: number = null
  public maxSerial: number = null
  public team: string = null            // 3 letter abbreviation when stored in DB

  // team, badges, series, tier, jersey #, highest mint
  public jersey: boolean = null
  public lastMint: boolean = null
  public neverSold: boolean = null
  public lowAsk: boolean = null         // Jan 12, 2022
  public tsdebut: boolean = null
  public rookieYear: boolean = null
  public rookieMint: boolean = null
  public rookiePremiere: boolean = null
  public champYear: boolean = null
  public challengeReward: boolean = null
  public craftingChallengeReward: boolean = null

  public description: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    return true
  }

  

}




(async () => {
})();

